import { useTestKh } from '@/hooks/useSettings'
import type { TestKhStatus } from '@/lib/schemas/settings'

/**
 * [Test KH API connection] button + result line. Shared by the Settings and
 * Health screens; owns its own busy state so it never blocks the rest of the
 * page. "Run this before calling Anthony."
 */

interface StatusDisplay {
  icon: string
  className: string
}

const STATUS: Record<TestKhStatus, StatusDisplay> = {
  connected: { icon: '✅', className: 'text-green-700' },
  auth_failed: { icon: '❌', className: 'text-red-700' },
  unreachable: { icon: '❌', className: 'text-red-700' },
  dry_run: { icon: 'ℹ️', className: 'text-blue-700' },
  disabled: { icon: '⚠️', className: 'text-amber-700' },
}

export function TestKhButton() {
  const test = useTestKh()

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => test.mutate()}
        disabled={test.isPending}
        className="border border-gray-800 px-3 py-1 text-sm hover:bg-gray-900 hover:text-white disabled:cursor-not-allowed disabled:opacity-50"
      >
        {test.isPending ? 'Testing…' : 'Test KH API connection'}
      </button>

      {test.isSuccess && (
        <p className={`flex items-center gap-1.5 text-sm ${STATUS[test.data.status].className}`}>
          <span aria-hidden="true">{STATUS[test.data.status].icon}</span>
          <span>{test.data.message}</span>
        </p>
      )}
      {test.isError && (
        <p role="alert" className="text-sm text-red-600">
          {test.error instanceof Error ? test.error.message : 'Connection test failed.'}
        </p>
      )}
    </div>
  )
}
